import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useCallback, useEffect } from "react";
import styles from "./footer.module.scss";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { useAppDispatch } from "../../hooks/redux";
import { onModalOpenClose } from "../../redux/reducers/modals";
import FooterPNL from "./footerPNL";
const leftTabIdValues = ["positions", "holdings", "orders", "vtt", "basket"];
const rightTabIdValues = ["watchlist", "screener", "news"];
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const handleChangeForClosingValues = (tabPosition, tabId) => {
    if (tabId) {
        const element = document.getElementById(tabId);
        element === null || element === void 0 ? void 0 : element.classList.toggle("activeTab");
    }
    if (tabPosition == "leftTab") {
        for (let i = 0; i < leftTabIdValues.length; i++) {
            if (leftTabIdValues[i] != tabId) {
                const deleteTabId = document.getElementById(leftTabIdValues[i]);
                deleteTabId === null || deleteTabId === void 0 ? void 0 : deleteTabId.classList.remove("activeTab");
            }
        }
    }
    else {
        for (let i = 0; i < rightTabIdValues.length; i++) {
            if (rightTabIdValues[i] != tabId) {
                const deleteTabId = document.getElementById(rightTabIdValues[i]);
                deleteTabId === null || deleteTabId === void 0 ? void 0 : deleteTabId.classList.remove("activeTab");
            }
        }
    }
};
const Footer = ({ leftModalId, rightModalId, leftFooterModalWidth, onModalStatusChange, }) => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        // if (leftModalId) {
        handleChangeForClosingValues("leftTab", leftModalId);
        // }
    }, [leftModalId]);
    useEffect(() => {
        // if (rightModalId) {
        handleChangeForClosingValues("rightTab", rightModalId);
        // }
    }, [rightModalId]);
    const onTabChange = useCallback((tabId) => {
        onModalStatusChange(tabId);
    }, [onModalStatusChange]);
    const handlePositionClick = () => {
        captureCleverTabAnalytics("Footer Position Tab clicked", {
            eventName: "Footer Position Tab clicked",
        });
    };
    const handleFooterOrderClick = () => {
        captureCleverTabAnalytics("Footer Order Tab clicked", {
            eventName: "Footer Order Tab clicked",
        });
    };
    const handleFooterVttClick = () => {
        captureCleverTabAnalytics("Footer VTT Tab clicked", {
            eventName: "Footer VTT Tab clicked",
        });
    };
    const handleFooterBasketClick = () => {
        captureCleverTabAnalytics("Footer Basket Tab clicked", {
            eventName: "Footer Basket Tab clicked",
        });
    };
    const handleFooterWatchlistClick = () => {
        captureCleverTabAnalytics("Footer Watchlist Tab clicked", {
            eventName: "Footer Watchlist Tab clicked",
        });
    };
    const handleFooterScreenerClick = () => {
        captureCleverTabAnalytics("Footer Screener Tab clicked", {
            eventName: "Footer Screener Tab clicked",
        });
    };
    const handleFooterNewsClick = () => {
        captureCleverTabAnalytics("Footer News Tab clicked", {
            eventName: "Footer News Tab clicked",
        });
    };
    return (_jsx("div", Object.assign({ className: `${styles.footerContainer} d-none d-sm-block` }, { children: _jsxs("div", Object.assign({ className: "d-flex flex-row align-items-center", style: {
                backgroundColor: "var(--bgColor2)",
            } }, { children: [_jsxs("div", Object.assign({ className: styles.leftFooter, style: { width: leftFooterModalWidth } }, { children: [_jsx(FooterPNL, { onTabChange: (data) => onTabChange(data), handlePositionClick: handlePositionClick }), _jsxs("div", Object.assign({ className: `${styles.tabView}`, id: "orders", onClick: () => {
                                var _a;
                                onTabChange("orders");
                                ((_a = document.getElementById("orders")) === null || _a === void 0 ? void 0 : _a.classList.contains("activeTab"))
                                    ? false
                                    : dispatch(onModalOpenClose({
                                        componentName: "OrdersDashboard",
                                        currState: "close",
                                    }));
                                handleFooterOrderClick();
                            } }, { children: [_jsx("span", { className: "orderTab" }), _jsx("span", Object.assign({ className: "mediumWeight ms-2" }, { children: " Orders " }))] })), _jsxs("div", Object.assign({ className: `${styles.tabView}`, id: "holdings", onClick: () => {
                                var _a;
                                onTabChange("holdings");
                                ((_a = document
                                    .getElementById("holdings")) === null || _a === void 0 ? void 0 : _a.classList.contains("activeTab"))
                                    ? false
                                    : dispatch(onModalOpenClose({
                                        componentName: "HoldingsDashboard",
                                        currState: "close",
                                    }));
                            } }, { children: [_jsx("span", { className: "holdingsTab" }), _jsx("span", Object.assign({ className: "mediumWeight ms-2" }, { children: " Holdings" }))] })), _jsxs("div", Object.assign({ className: `${styles.tabView}`, id: "vtt", onClick: () => {
                                var _a;
                                onTabChange("vtt");
                                ((_a = document.getElementById("vtt")) === null || _a === void 0 ? void 0 : _a.classList.contains("activeTab"))
                                    ? false
                                    : dispatch(onModalOpenClose({
                                        componentName: "VTTDashboard",
                                        currState: "close",
                                    }));
                                handleFooterVttClick();
                            } }, { children: [_jsx("span", { className: "vttTab" }), _jsx("span", Object.assign({ className: "mediumWeight ms-2" }, { children: " VTT " }))] })), _jsxs("div", Object.assign({ className: `${styles.tabView}`, id: "basket", onClick: () => {
                                var _a;
                                onTabChange("basket");
                                ((_a = document.getElementById("basket")) === null || _a === void 0 ? void 0 : _a.classList.contains("activeTab"))
                                    ? false
                                    : dispatch(onModalOpenClose({
                                        componentName: "basket",
                                        currState: "close",
                                    }));
                                handleFooterBasketClick();
                            } }, { children: [_jsx("span", { className: "basketTab" }), _jsx("span", Object.assign({ className: "mediumWeight ms-2" }, { children: " Basket " }))] }))] })), _jsxs("div", Object.assign({ className: styles.rightFooter }, { children: [_jsxs("div", Object.assign({ className: `${styles.tabView}`, id: "watchlist", onClick: () => {
                                var _a;
                                onTabChange("watchlist");
                                ((_a = document
                                    .getElementById("watchlist")) === null || _a === void 0 ? void 0 : _a.classList.contains("activeTab"))
                                    ? false
                                    : dispatch(onModalOpenClose({
                                        componentName: "watchlist",
                                        currState: "close",
                                    }));
                                handleFooterWatchlistClick();
                            } }, { children: [_jsx("span", { className: "watchlistTab" }), _jsx("span", Object.assign({ className: "mediumWeight ms-2" }, { children: " Watchlist " }))] })), _jsxs("div", Object.assign({ className: `${styles.tabView}`, id: "screener", onClick: () => {
                                var _a;
                                onTabChange("screener");
                                ((_a = document
                                    .getElementById("screener")) === null || _a === void 0 ? void 0 : _a.classList.contains("activeTab"))
                                    ? false
                                    : dispatch(onModalOpenClose({
                                        componentName: "screener",
                                        currState: "close",
                                    }));
                                handleFooterScreenerClick();
                            } }, { children: [_jsx("span", { className: "screenerTab" }), _jsx("span", Object.assign({ className: "mediumWeight ms-2" }, { children: " Screener " }))] })), _jsxs("div", Object.assign({ className: `${styles.tabView}`, id: "news", onClick: () => {
                                var _a;
                                onTabChange("news");
                                ((_a = document.getElementById("news")) === null || _a === void 0 ? void 0 : _a.classList.contains("activeTab"))
                                    ? false
                                    : dispatch(onModalOpenClose({
                                        componentName: "news",
                                        currState: "close",
                                    }));
                                handleFooterNewsClick();
                            } }, { children: [_jsx("span", { className: "newsTab" }), _jsx("span", Object.assign({ className: "mediumWeight ms-2" }, { children: " News " }))] }))] }))] })) })));
};
export default Footer;
